import React from 'react';
import { Switch } from 'react-router-dom';

import ErrorBoundaryRoute from 'app/shared/error/error-boundary-route';

import ParProductUnit from './par-product-unit';
import ParProductUnitDetail from './par-product-unit-detail';
import ParProductUnitUpdate from './par-product-unit-update';
import ParProductUnitDeleteDialog from './par-product-unit-delete-dialog';

const Routes = ({ match }) => (
  <>
    <Switch>
      <ErrorBoundaryRoute exact path={`${match.url}/new`} component={ParProductUnitUpdate} />
      <ErrorBoundaryRoute exact path={`${match.url}/:id/edit`} component={ParProductUnitUpdate} />
      <ErrorBoundaryRoute exact path={`${match.url}/:id`} component={ParProductUnitDetail} />
      <ErrorBoundaryRoute path={match.url} component={ParProductUnit} />
    </Switch>
    <ErrorBoundaryRoute exact path={`${match.url}/:id/delete`} component={ParProductUnitDeleteDialog} />
  </>
);

export default Routes;
